




























import { defineComponent, computed } from '@vue/composition-api';
import type { Tab } from '@getaccept/lib-ui';
import { DateTime } from 'luxon';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { GroupFilter } from '@getaccept/lib-shared/src/enums/group-filter';

export default defineComponent({
  name: 'DashboardHeader',
  props: {
    groupFilter: {
      type: String,
      default: GroupFilter.My,
    },
    isAdmin: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const filterTabs = computed((): Tab[] => [
      {
        label: t('show-mine').toString(),
        key: GroupFilter.My,
      },
      {
        label: t('show-all').toString(),
        key: GroupFilter.All,
      },
    ]);

    const date = computed((): string => DateTime.now().toLocaleString(DateTime.DATE_MED));

    return { filterTabs, date };
  },
});
